// The order screens' words in English, by key: the fallback of the CMS
// TextBundle "store_orders" (./useOrderTexts.js), and what it is seeded from.
export default {
  order_n_details: "Order %s · details",
  to_manage_your_order_scan_the_code: "To manage your order, scan the code",
  to_manage_your_order_open: "To manage your order, open:",
  it_opens_order_n_in_your_account_sign_in_with_n: "It opens order %s in your account: sign in with %s.",
  returning_items: "Returning items",
  you_can_return_items_within_n_days_of_receiving_: "You can return items within %s days of receiving them, without giving a reason. Everything is done from your account on the site.",
  sign_in_at_n_with_the_email_you_ordered_with_n: "Sign in at %s with the email you ordered with (%s).",
  sign_in_on_the_site_with_the_email_you_ordered_w: "Sign in on the site with the email you ordered with (%s).",
  open_my_account_orders_and_find_order_n: "Open My account → Orders and find order %s.",
  or_go_straight_to: "Or go straight to:",
  open_the_order_choose_the_request_for_return_tab: "Open the order, choose the “Request for return” tab, pick the items and the reason, and send the request.",
  the_seller_answers_by_email_and_in_your_order_wi: "The seller answers by email, and in your order, with where to send the items.",
  pack_the_items_write_the_order_number_n_on_the_p: "Pack the items, write the order number %s on the parcel or put this sheet inside, and send it.",
  once_the_seller_receives_the_items_the_money_goe: "Once the seller receives the items, the money goes back the way you paid. You are told by email.",
  return_address: "Return address",
  questions_about_your_order: "Questions about your order",
  where_the_order_stands: "Where the order stands",
  printed_n: "Printed %s",
  shipped: "Shipped",
  courier_status: "Courier status",
  completes_automatically: "Completes automatically",
  waiting_for_you: "Waiting for you",
  a_cancellation_request_to_answer: "A cancellation request to answer",
  n_return_request_s_to_answer: "%s return request(s) to answer",
  n_accepted_return_s_on_their_way_back: "%s accepted return(s) on their way back",
  edit: "Edit",
  add_now: "Add now",
  update: "Update",
  return_address_saved: "Return address saved",
  enter_the_return_address: "Enter the return address",
  physical_items_return_address: "Physical items return address",
  where_buyers_send_items_back_written_as_it_goes_: "Where buyers send items back. Written as it goes on the parcel. It is kept in your Delivery settings.",
  company_name_warehouse_or_office_street_and_numb: "Company name\nWarehouse or office\nStreet and number\nPostcode City, Country",
  the_buyer_is_sent_this_return_address: "The buyer is sent this return address:",
  you_have_no_return_address_yet_add_your_physical: "You have no return address yet. Add your physical items return address in your Delivery settings first: the buyer needs it to send the items back.",
  add_your_return_address_in_your_delivery_setting: "Add your return address in your Delivery settings first",
  n_is_called_off_and_the_buyer_is_told_by_email_a: "%s is called off and the buyer is told by email. Any money already taken is given back separately, with Refund.",
  message_to_the_buyer_optional: "Message to the buyer (optional)",
  for_example_the_item_is_out_of_stock: "For example: the item is out of stock",
  order_canceled_the_buyer_was_told: "Order canceled, the buyer was told",
  n_of_n_returned: "%s of %s returned",
  enter_the_parcel_s_tracking_number: "Enter the parcel's tracking number",
  mark_n_as_shipping_and_send_the_shipping_mail_wi: "Mark %s as shipping and send the shipping mail, with the tracking number, to %s.",
  change_the_tracking_number: "Change the tracking number",
  add_the_tracking_number: "Add the tracking number",
  save: "Save",
  tracking_number_saved: "Tracking number saved",
  another_courier: "Another courier",
  tracking_number_required: "Tracking number (required)",
  the_number_on_the_waybill: "The number on the waybill",
  e_g_s: "e.g. %s",
  a_box_now_parcel_number_has_10_digits_e_g_12345: "A BOX NOW parcel number has 10 digits, e.g. 1234567890",
  a_speedy_shipment_number_has_10_to_14_digits_e: "A Speedy shipment number has 10 to 14 digits, e.g. 63773846777",
  this_is_not_a_valid_tracking_number: "This is not a valid tracking number",
  tracking_link_optional: "Tracking link (optional)",
  waiting_for_the_courier: "Waiting for the courier",
  waiting_for_the_buyer_to_collect_it: "Waiting for the buyer to collect it",
  delivered: "Delivered",
  coming_back_to_you: "Coming back to you",
  delivered_back_to_you: "Delivered back to you",
  problem_with_the_parcel: "Problem with the parcel",
  the_parcel_is_coming_back_to_you_so_the_order_do: "The parcel is coming back to you, so the order does not complete by itself.",
  the_parcel_was_delivered_back_to_you_so_the_orde: "The parcel was delivered back to you, so the order does not complete by itself.",
  the_courier_reports_a_problem_with_the_parcel_so: "The courier reports a problem with the parcel, so the order does not complete by itself.",
  a_return_request_is_in_progress_so_the_order_doe: "A return request is in progress, so the order does not complete by itself.",
  a_cancellation_request_is_waiting_for_your_answe: "A cancellation request is waiting for your answer, so the order does not complete by itself.",
  items_came_back_so_the_order_does_not_complete_b: "Items came back, so the order does not complete by itself.",
  the_order_was_refunded_in_full: "The order was refunded in full.",
  tracking: "Tracking",
  no_tracking_number_yet: "No tracking number yet",
  change: "Change",
  add_tracking_number: "Add tracking number",
  the_courier_could_not_be_reached_the_last_time_i: "The courier could not be reached the last time; it is asked again every few hours.",
  the_order_completes_when_the_courier_confirms_de: "The order completes when the courier confirms delivery.",
  unless_the_courier_confirms_delivery_sooner_the_: "Unless the courier confirms delivery sooner, the order completes automatically on %s.",
  automatic_completion_is_off_in_your_delivery_set: "Automatic completion is off in your Delivery settings: complete the order when the buyer has it.",
  hide_the_courier_s_events: "Hide the courier's events",
  show_the_courier_s_events_n: "Show the courier's events (%s)",
  marked_as_shipped_tracking_n: "Marked as shipped · tracking %s",
  delivered_confirmed_by_the_courier: "Delivered: confirmed by the courier",
  completed_automatically_n_days_after_shipping: "Completed automatically, %s days after shipping",
  tracking_number_set_n: "Tracking number set · %s",
  the_courier_is_returning_the_parcel_to_you: "The courier is returning the parcel to you",
  the_parcel_was_delivered_back_to_you: "The parcel was delivered back to you",
  the_courier_reports_a_problem_with_the_parcel: "The courier reports a problem with the parcel",
  // the order after its refunds (OrderPage: Items, the Refunds tab, the totals) and the refund
  // dialog's "Refund [2] units" — said by key: "Refund" is the action's word too, so these come
  // first, and the English "Refund" still finds the action's key (the last of a word wins)
  refund_quantity_label: "Refund",
  refund_quantity_units: "units",
  refunds_n: "Refunds (%s)",
  every_item_was_refunded: "Every item was refunded",
  n_refunded_qty: "%s refunded",
  items_ordered: "Items ordered",
  net_paid: "Total",
  date: "Date",
  refund_of: "Refund of",
  amount: "Amount",
  made_outside_the_store: "Made outside the store",
  nothing_left_to_ship_delivery_back: "Nothing is left to ship, so the delivery goes back too",
  n_goes_back_to_open_paid_and_waiting_to_be_sent: "%s goes back to open — paid and waiting to be sent. Nothing is mailed to the buyer.",
  n_is_called_off_any_money_already_taken_is_given: "%s is called off. Any money already taken is given back separately, with Refund.",
  n_locker_id: "%s locker id:",
  n_office_id: "%s office id:",
  n_off: "−%s off",
  n_refunded: "−%s refunded",
  address: "Address",
  all_of_it_given_back: "All of it given back",
  back_to_open_paid_waiting_to_be_sent: "Back to open: paid, waiting to be sent",
  call_the_order_off_money_is_given_back_separatel: "Call the order off; money is given back separately",
  called_off: "Called off",
  cancel: "Cancel",
  cancel_the_order: "Cancel the order",
  cancel_this_order: "Cancel this order",
  canceled: "canceled",
  canceled_2: "Canceled",
  complete: "Complete",
  complete_this_order: "Complete this order",
  n_is_done_the_buyer_has_it_nothing_is_mailed: "%s is done — the buyer has it. Nothing is mailed to the buyer.",
  completed: "completed",
  completed_2: "Completed",
  courier: "Courier",
  custom_range: "Custom Range",
  customer: "Customer",
  customer_contacts: "Customer contacts",
  day: "day",
  deliver_to_locker: "Deliver to locker",
  deliver_to_office: "Deliver to office",
  delivered_and_done: "Delivered and done",
  delivery: "Delivery",
  delivery_to_address: "Delivery to address",
  discount: "Discount",
  discounted_lines: "Discounted lines",
  free: "Free",
  give_the_card_payment_back_wholly_or_by_the_line: "Give the card payment back, wholly or by the line",
  invoice_to: "Invoice to",
  item: "Item",
  items: "Items",
  items_n: "Items (%s)",
  items_before_discount: "Items before discount",
  keep_it: "Keep it",
  last_24_hours: "Last 24 Hours",
  last_30_days: "Last 30 Days",
  last_365_days: "Last 365 Days",
  last_7_days: "Last 7 Days",
  last_90_days: "Last 90 Days",
  leave_it: "Leave it",
  lifetime: "Lifetime",
  loading: "Loading…",
  mark_n_as_shipping_and_send_the_shipping_mail_to: "Mark %s as shipping and send the shipping mail to %s?",
  mark_as_on_its_way_and_mail_the_buyer: "Mark as on its way and mail the buyer",
  marked_as_shipping_the_buyer_was_told: "Marked as shipping, the buyer was told",
  no: "No",
  no_orders_in_this_period: "No orders in this period",
  on_its_way: "On its way",
  open: "Open",
  order: "Order",
  order_n: "Order %s",
  order_actions: "Order actions",
  order_canceled: "Order canceled",
  order_completed: "Order completed",
  order_not_found: "Order not found",
  order_number_email_phone_product_tracking_number: "Order number, email, phone, product, tracking number…",
  order_reopened: "Order reopened",
  orders: "Orders",
  paid: "Paid",
  paid_waiting_to_be_sent: "Paid, waiting to be sent",
  partly_refunded: "Partly refunded",
  pickup_at_office: "Pickup at office",
  pickup_from_locker: "Pickup from locker",
  pickup_from_office: "Pickup from office",
  placed: "Placed",
  placed_n: "Placed %s",
  price: "Price",
  print: "Print",
  copy_order_id: "Copy order ID",
  order_id_copied: "Order ID copied",
  could_not_copy: "Could not copy",
  history: "History",
  order_placed_and_paid_n: "Order placed and paid · %s",
  order_placed_n: "Order placed · %s",
  paid_on_delivery_n: "Paid on delivery · %s",
  paid_in_cash_on_delivery: "Paid in cash on delivery",
  waiting_to_be_sent: "Waiting to be sent",
  back_to_open_waiting_to_be_sent: "Back to open: waiting to be sent",
  n_goes_back_to_open_waiting_to_be_sent: "%s goes back to open — waiting to be sent. Nothing is mailed to the buyer.",
  marked_as_shipped: "Marked as shipped",
  marked_as_delivered: "Marked as delivered",
  return_request_n_sent_by_the_buyer: "Return request #%s sent by the buyer",
  return_request_n_canceled_by_the_buyer: "Return request #%s canceled by the buyer",
  return_request_n_accepted: "Return request #%s accepted",
  return_request_n_declined: "Return request #%s declined",
  items_returned_n: "Items returned (%s)",
  every_item_is_back: "Every item is back",
  partial_refund_n: "Partial refund · %s",
  refunded_in_full_n: "Refunded in full · %s",
  by_n: "by %s",
  delivery_n: "Delivery · %s",
  refunded_so_far_n: "Refunded so far: %s",
  nothing_has_happened_to_this_order_yet: "Nothing has happened to this order yet",
  partly_refunded_state: "partly refunded",
  waiting_for_your_answer_or_for_the_items: "Waiting for your answer or for the items",
  waiting_for_items: "waiting for items",
  item_returned: "item returned",
  show_the_orders_other_items: "Show the order's other items",
  from_return_requests: "From return requests",
  waiting_for_the_goods_use_order_actions_returned: "Waiting for the goods — when they arrive, use Order actions → Returned",
  return_request_n: "Return request #%s",
  items_to_return_n: "Items to return (%s)",
  you: "You",
  buyer: "Buyer",
  no_note: "No note",
  canceled_by_the_buyer_event: "Canceled by the buyer",
  goods_received_event: "Goods received",
  you_accepted_the_request: "You accepted the request",
  you_declined_the_request: "You declined the request",
  waiting_for_your_answer_dots: "Waiting for your answer…",
  send: "Send",
  close: "Close",
  // a buyer's return request: the requests tab, the answer, the tile
  thank_you_for_your_request_please_send_the_items_back_to_us_we_will_refund_your: "Thank you for your request. Please send the items back to us — we will refund your order as soon as we receive the delivery.",
  accept_the_return_request: "Accept the return request",
  decline_the_return_request: "Decline the return request",
  the_buyer_is_told_by_mail_with_your_message_when_the_parcel_arrives_mark_it_as_r: "The buyer is told by mail, with your message. When the parcel arrives, mark it as returned from the request.",
  the_buyer_is_told_by_mail_with_your_reason: "The buyer is told by mail, with your reason.",
  message_to_the_buyer: "Message to the buyer",
  why_the_request_is_declined_required: "Why the request is declined (required)",
  accept: "Accept",
  decline: "Decline",
  tell_the_buyer_why_the_request_is_declined: "Tell the buyer why the request is declined",
  request_accepted_the_buyer_was_told: "Request accepted, the buyer was told",
  request_declined_the_buyer_was_told: "Request declined, the buyer was told",
  return_requested: "return requested",
  return_requests_n: "Return requests (%s)",
  waiting_for_your_answer: "waiting for your answer",
  accepted: "accepted",
  declined: "declined",
  canceled_by_the_buyer: "canceled by the buyer",
  after_the_return_period: "after the return period",
  goods_received: "goods received",
  your_answer: "Your answer",
  goods_arrived_mark_as_returned: "Goods arrived: mark as returned",
  return_requests: "Return requests",
  waiting_for_your_answer_x: "Waiting for your answer",
  // goods coming back to the seller (ReturnDialog, the Returns tab, the Returned tile)
  goods_returned: "Returned",
  order_returned_state: "returned",
  the_goods_came_back_not_collected_or_sent_back: "The goods came back: not collected, or sent back",
  partly_returned: "partly returned",
  returns_n: "Returns (%s)",
  reason: "Reason",
  what_came_back: "What came back",
  back_on_sale: "Back on sale",
  kept_out_of_stock: "Kept out of stock",
  marked_as_returned: "Marked as returned",
  the_goods_came_back: "The goods came back",
  not_collected_or_refused: "Not collected or refused",
  changed_their_mind_withdrawal: "Changed their mind (withdrawal)",
  wrong_size_or_fit: "Wrong size or fit",
  not_as_described: "Not as described",
  wrong_item_sent: "Wrong item sent",
  defective: "Defective",
  damaged_in_transit: "Damaged in transit",
  other: "Other",
  mark_order_n_as_returned: "Mark order %s as returned",
  refund_the_returned_goods_next: "Refund the returned goods next",
  nothing_is_left_to_refund: "Nothing is left to refund",
  mark_as_returned: "Mark as returned",
  within_the_n_day_return_period_which_ends_on_n: "Within the %s-day return period, which ends on %s.",
  the_n_day_return_period_ended_on_n_you_may_still_take_the_goods_back: "The %s-day return period ended on %s. You may still take the goods back.",
  not_marked_as_delivered_a_parcel_that_comes_back_undelivered: "Not marked as delivered: a parcel that comes back undelivered.",
  why_did_it_come_back: "Why did it come back?",
  note_required: "Note (required)",
  note_optional: "Note (optional)",
  what_the_buyer_or_the_courier_said: "What the buyer or the courier said",
  n_of_n_can_come_back: "%s of %s can come back",
  put_the_goods_back_on_sale: "Put the goods back on sale",
  they_go_back_into_stock: "They go back into stock.",
  they_stay_out_of_stock_damaged_or_not_sellable: "They stay out of stock: damaged or not sellable.",
  the_return_was_not_recorded: "The return was not recorded",
  the_return_could_not_be_recorded: "The return could not be recorded",
  saving: "Saving…",
  order_refunded_state: "refunded",
  promo_code: "Promo code",
  promo_code_n: "Promo code %s",
  qty: "Qty",
  recipient: "Recipient",
  refund: "Refund",
  refunded: "Refunded",
  refunded_the_buyer_was_told: "Refunded, the buyer was told",
  refunds: "Refunds",
  reopen: "Reopen",
  reopen_this_order: "Reopen this order",
  see_on_map: "See on map",
  ship: "Ship",
  ship_this_order: "Ship this order",
  shipping: "shipping",
  shipping_2: "Shipping",
  shipping_method: "Shipping method:",
  shipping_n: "Shipping%s",
  show_every_order_again: "Show every order again",
  some_of_it_given_back: "Some of it given back",
  status: "Status",
  the_buyer_has_it_the_order_is_done: "The buyer has it — the order is done",
  total: "Total",
  vat_n: "VAT %s",
  yes: "Yes",
  just_now: "just now",
  n_m_ago: "%sm ago",
  n_h_ago: "%sh ago",
  n_day_ago: "%s day ago",
  n_days_ago: "%s days ago",
  n_week_ago: "%s week ago",
  n_weeks_ago: "%s weeks ago",
  n_month_ago: "%s month ago",
  n_months_ago: "%s months ago",
  n_year_ago: "%s year ago",
  n_years_ago: "%s years ago",
  subscription_payment: "Subscription payment",
  subscription_renewal: "Subscription renewal",
  kind: "Kind",
  // the refund dialog (aldoo-ra/Admin/Store/Refunds/RefundDialog.jsx)
  n_each: "%s each",
  n_of_n_left: "%s of %s left",
  full_amount: "Full amount",
  remaining: "Remaining",
  a_share_of_what_is_left: "a share of what is left",
  an_exact_sum: "an exact sum",
  everything_left_n_delivery_included: "everything left (%s), delivery included",
  everything_left_n: "everything left (%s)",
  percent: "Percent",
  fixed: "Fixed",
  enter_a_percent_from_1_to_100: "Enter a percent from 1 to 100, with at most 2 decimals",
  enter_an_amount_above_0: "Enter an amount above 0, with at most 2 decimals",
  a_refund_is_given_back_in_the_currency: "A refund is given back in the currency the order was charged in, and nothing goes back on the shelf.",
  out_of_stock_damaged_in_transit: "Out of stock, damaged in transit…",
  refund_n_to_the_customer: "Refund %s to the customer?",
  note_to_the_customer_optional: "Note to the customer (optional)",
  confirm: "Confirm",
  refund_amount: "Refund amount:",
  refund_order_n: "Refund order %s",
  refunding: "Refunding…",
  selected_items: "Selected items",
  share_of_the_order_discount_taken_off: "share of the order discount taken off",
  that_is_n_more_than_is_left_to_refund: "That is %s — more than is left to refund.",
  the_refund_could_not_be_made: "The refund could not be made",
  the_refund_was_not_made: "The refund was not made",
  cancellation_requested: "cancellation requested",
  the_buyer_asks_to_cancel_this_order: "The buyer asks to cancel this order",
  do_not_send_it_before_you_answer: "Do not send it before you answer.",
  cancel_and_refund: "Cancel and refund",
  cancel_order: "Cancel order",
  decline_cancellation: "Decline cancellation",
  modify_order_n: "Modify order %s",
  modify_order: "Modify order",
  change_quantities_take_items_out_or_add_others_: "Change quantities, take items out or add others — the buyer is told",
  to_collect_on_delivery: "To collect on delivery",
  save_changes: "Save changes",
  change_quantities_the_buyer_gets_an_email: "Change quantities, take items out or add others. The buyer gets an email with the changes and your message. The delivery fee stays as chosen.",
  n_in_stock: "%s in stock",
  out_of_stock: "out of stock",
  add: "Add",
  added: "added",
  was_n: "was %s",
  taken_out: "taken out",
  only_n_in_stock: "Only %s in stock",
  put_it_back: "Put it back",
  take_it_out: "Take it out",
  search_products_to_add: "Search products to add…",
  searching: "Searching…",
  no_products_found: "No products found",
  eg_we_are_out_of_the_red_one: "E.g. We are out of the red one, so we put in the blue one in the same size.",
  an_order_needs_at_least_one_item_cancel_it_inst: "An order needs at least one item: cancel it instead.",
  not_enough_in_stock_n: "Not enough in stock: %s",
  a_waybill_was_made_for_this_order_cancel_it_fir: "A waybill was made for this order: cancel it first",
  the_buyer_asked_to_cancel_this_order_answer_the: "The buyer asked to cancel this order: answer the request first",
  only_an_order_waiting_to_be_sent_can_be_modifie: "Only an order waiting to be sent can be modified",
  only_an_order_paid_on_delivery_can_be_modified: "Only an order paid on delivery can be modified",
  nothing_was_changed: "Nothing was changed",
  order_changed_the_buyer_was_told: "Order changed, the buyer was told",
  order_changed: "Order changed",
  added_n_pcs: "added, %s pcs",
  these_changes_are_saved_and_the_buyer_is_told_b: "These changes are saved and the buyer is told by email:",
  back: "Back",
  n_goes_back_to_the_buyers_card: "%s goes back to the buyer's card.",
  n_went_back_to_the_buyers_card: "%s went back to the buyer's card.",
  a_new_order_is_placed_with_n_who_gets_it_as_any: "A new order is placed with %s, who gets it as any new order. Order %s is canceled and %s is told not to send it. The buyer is told by email.",
  add_the_sellers_products_the_buyer_gets: "Add the seller's products the buyer gets.",
  aldoo_covers_n_up_to_n: "Aldoo covers %s (up to %s).",
  aldoo_covers_n: "Aldoo covers %s.",
  another_seller_sends_it_instead_the_buyer_the_a: "Another seller sends it instead — the buyer, the address and the delivery go over",
  change_the_office: "Change the office",
  charged_to_the_card: "Charged to the card",
  choose_the_delivery: "Choose the delivery",
  choose_the_office: "Choose the office",
  choose_the_office_or_locker: "Choose the office or locker",
  eg_as_agreed_on_the_phone_your_book_is_sent_by_: "E.g. As agreed on the phone, your book is sent by another bookshop.",
  move_blocked_the_new_total_is_n_more_than_was_c: "Move blocked: the new total is %s more than was charged, and Aldoo covers at most %s. Lower it.",
  move_order_n: "Move order %s",
  move_order_n_to_another_seller: "Move order %s to another seller",
  move_the_order: "Move the order",
  move_to_another_seller: "Move to another seller",
  moved_here_from_n_order: "Moved here from %s, order",
  moved_to_n_as_order: "Moved to %s as order",
  moved_to_another_seller_n: "Moved to another seller · %s",
  moved_order_n_with_the_new_seller_the_buyer_was: "Moved: order %s with the new seller, the buyer was told",
  new_total: "New total",
  no_delivery: "No delivery",
  no_sellers_found: "No sellers found",
  not_found_at_n: "Not found at %s:",
  search_ns_products_to_add: "Search %s's products to add…",
  search_sellers: "Search sellers…",
  the_buyer_chose: "The buyer chose",
  the_new_seller_does_not_deliver_this_way_choose: "The new seller does not deliver this way: choose another",
  the_new_total_is_more_than_aldoo_can_cover_lowe: "The new total is more than Aldoo can cover: lower it",
  these_products_cannot_go_this_way: "These products cannot go this way",
  this_delivery_is_not_available: "This delivery is not available",
  with_the_new_seller: "With the new seller",
  choose_the_seller: "choose the seller",
  instead_of_n: "instead of %s",
  pickup: "pickup",
  the_buyer_chose_n: "the buyer chose %s",
  to_a_locker: "to a locker",
  to_an_office: "to an office",
  to_the_address: "to the address",
  change_link: "change",
  no_street_address_the_buyer_collects_at_n: "No street address: the buyer collects at %s",
  replacement_for_n: "Replacement for %s",
  cancel_link: "cancel",
  search_ns_products: "Search %s's products…",
  left_out_of_the_new_order: "Left out of the new order",
  not_found_at_n_choose_a_replacement_or_leave_it: "Not found at %s: choose a replacement or leave it out",
  replace_with_another_product: "Replace with another product",
  choose_a_replacement: "Choose a replacement",
  change_the_product: "Change the product",
  leave_it_out: "Leave it out",
  reason_told_to_n: "Reason, told to %s",
  why_it_is_moved_told_to_n_required: "Why it is moved — told to %s (required)",
  eg_the_order_was_not_sent_within_3_days_of_the_: "E.g. The order was not sent within 3 days of the promised date.",
  aldoo_moved_this_order_to_be_fulfilled_elsewher: "Aldoo moved this order to be fulfilled elsewhere: do not send it.",
  n_is_canceled_nothing_was_paid_so_no_money_goes: "%s is canceled. Nothing was paid, so no money goes back. The buyer is told by mail, with your message.",
  accept_the_buyers_request_and_call_the_order_off: "Accept the buyer's request and call the order off",
  cancel_the_order_and_refund: "Cancel the order and refund",
  decline_the_cancellation: "Decline the cancellation",
  n_is_canceled_and_what_is_left_of_the_payment_n_: "%s is canceled and what is left of the payment (%s) goes back to the buyer. They are told by mail, with your message.",
  the_order_stays_and_will_be_sent_the_buyer_is_to: "The order stays and will be sent. The buyer is told by mail, with your reason.",
  why_the_cancellation_is_declined_required: "Why the cancellation is declined (required)",
  tell_the_buyer_why_the_cancellation_is_declined: "Tell the buyer why the cancellation is declined",
  order_canceled_and_refunded_the_buyer_was_told: "Order canceled and refunded, the buyer was told",
  cancellation_declined_the_buyer_was_told: "Cancellation declined, the buyer was told",
  proceed: "Proceed",
  the_buyer_just_asked_to_cancel_this_order: "The buyer just asked to cancel this order",
  the_buyer_withdrew_their_cancellation_request: "The buyer withdrew their cancellation request",
  the_buyer_just_asked_to_return_items_of_this_ord: "The buyer just asked to return items of this order",
  the_buyer_withdrew_their_return_request: "The buyer withdrew their return request",
  thank_you_for_letting_us_know_in_time: "Thank you for letting us know in time.",
  the_buyer_asked_to_cancel_n_shipping_it_declines: "The buyer asked to cancel %s. Shipping it declines their request and tells them. Ship anyway?",
  cancellation_requested_by_the_buyer: "Cancellation requested by the buyer",
  cancellation_request_withdrawn_by_the_buyer: "Cancellation request withdrawn by the buyer",
  cancellation_accepted: "Cancellation accepted",
  cancellation_declined: "Cancellation declined",
  ordered_by_mistake: "Ordered by mistake",
  changed_their_mind: "Changed their mind",
  found_it_cheaper_elsewhere: "Found it cheaper elsewhere",
  delivery_takes_too_long: "Delivery takes too long",
  another_reason: "Another reason",
  cancellation_requests: "Cancellation requests",
  waiting_for_your_answer_do_not_send_them: "Waiting for your answer: do not send them",
  returns: "Returns",
  // the order's buyer across their orders (aldoo-ra StoreOrders ClientPanel: the Client tab, its dialog)
  client_tab: "Client",
  client_see: "See the customer",
  client_returns_refunds_n: "%s returns/refunds",
  client_has_returns: "This customer has returns or refunds",
  client_nothing_known: "Nothing is known of this customer yet",
  client_first_order_n: "First order %s",
  client_last_n: "last %s",
  client_all_orders: "See all orders by this customer",
  client_warning: "This customer has returned goods or had money back on their orders. Check the order before you send it.",
  client_canceled_n: "%s canceled",
  client_partly_returned: "Partly returned",
  client_ltv: "Lifetime value",
  client_given_back_n: "%s given back",
  client_orders_by_n: "Orders by %s",
  client_search: "Order number or product…",
  client_this_order: "this order",
  client_products: "Products",
  client_no_orders: "No orders found",
  ready_for_pickup: "Ready for pickup",
  the_buyer_asked_to_cancel_n_marking_it_ready_dec: "The buyer asked to cancel %s. Marking it ready declines their request and tells them. Continue?",
  mark_n_as_ready_for_pickup_and_email_n_that_it_i: "Mark %s as ready for pickup and email %s that it is waiting at your shop.",
  marked_as_ready_for_pickup: "Marked as ready for pickup",
  the_order_waits_at_your_shop_the_buyer_pays_when: "The order waits at your shop: the buyer pays when collecting it",
  the_order_waits_at_your_shop_mail_the_buyer: "The order waits at your shop: mail the buyer",
  pickup_from_the_shop: "Pickup from the shop",
  collected_at_your_shop: "Collected at your shop",
  the_buyer_collects_it_at_your_shop: "The buyer collects it at your shop",
  pay_at_the_shop: "Pay at the shop",
  not_paid_yet_the_buyer_pays_when_collecting_it_a: "Not paid yet. The buyer pays when collecting it at your shop.",
  paid_at_the_shop: "Paid at the shop",
  to_pay_at_the_shop: "To pay at the shop",
  preorder: "Pre-order",
  this_order_contains_preorder_items: "This order contains pre-order items",
  ship_it_once_they_are_released_on_n: "Ship it once they are released, on %s.",
  the_buyer_was_promised_delivery_by_n: "The buyer was promised delivery by %s.",
  preorder_released_n: "Pre-order · released %s",
}
